/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Header, Label, Segment } from '@mairistem/composants';

import { COLORS } from '@/constants';
import type { Property } from 'csstype';

interface Props {
  title: string;
  width?: Property.Width;
  height?: Property.Height;
  children: React.ReactNode;
}

const Section = (props: Props) => {
  const { title, width = '100%', height = '100%', children } = props;

  return (
    <Segment
      raised
      style={{
        width,
        height,
        borderRadius: '16px',
        border: `solid 1px ${COLORS.SectionBorderColor}`,
      }}
    >
      <Label
        attached="top"
        style={{
          backgroundColor: COLORS.Background,
          borderRadius: '16px 16px 0 0',
        }}
        content={
          <Header
            as="h4"
            content={title}
            textAlign="center"
            style={{ color: 'white' }}
          />
        }
      />
      {children}
    </Segment>
  );
};

export default Section;
